module.exports = __webpack_public_path__ + "static/media/power-transmission.7fc909a3.jpg";